// extracted by mini-css-extract-plugin
export default {"spin":"GenerateLoading__spin--xYvtB"};